export function DefaultTooltipRenderer({
  tooltip,
}: {
  tooltip: { content: string; x: number; y: number } | null;
}) {
  if (!tooltip) return null;
  return (
    <div
      className="absolute bg-pureWhite p-2 rounded-sm whitespace-nowrap text-sm border border-backgroundGray"
      style={{
        top: tooltip.y,
        left: tooltip.x,
      }}
    >
      <span className="text-feintGray font-medium">{tooltip.content}</span>
    </div>
  );
}
